
export const toTableRowItems = (items: ReturoReport[]) =>
  items.map((item: ReturoReport) => ({
    id: item.id,
    noticeNumber: item.noticeNumber || '',
    cmrNumber: item.cmrNumber || '',
    truckNumber: item.truckNumber || '',
    driverName: item.driverName || '',
    createdBy: item.createdBy || '',
    created: item.created || '',
    shopName: item.shopName || '',
    shopCode: item.shopCode || '',
    providerName: item.providerName || '',
    status: item.status || '',
    statusValue: item.statusValue || '',
    idReturo: item.idReturo || '',
    sealList: item.sealList
  }))
